import { z } from 'zod';

/**
 * Validation schema for report download form
 * Requires name, email, LinkedIn URL, and marketing consent
 */
export const reportDownloadFormSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters'),
  email: z.string().email('Invalid email address'),
  linkedinUrl: z
    .string()
    .url('Please enter a valid URL')
    .refine(
      (url) => url.includes('linkedin.com/'),
      'Please enter a valid LinkedIn profile URL'
    ),
  marketingConsent: z.literal(true, {
    errorMap: () => ({ message: 'You must agree to receive the report and updates' }),
  }),
});

/**
 * Server-side validation schema including Turnstile token
 * Extends the base schema with optional bot protection (disabled in development)
 */
export const reportDownloadFormSchemaWithTurnstile = reportDownloadFormSchema.extend({
  turnstileToken: z.string().optional(),
});

/**
 * TypeScript type inferred from the Zod schema
 */
export type ReportDownloadFormData = z.infer<typeof reportDownloadFormSchema>;

/**
 * Server-side type including Turnstile token
 */
export type ReportDownloadFormDataWithTurnstile = z.infer<typeof reportDownloadFormSchemaWithTurnstile>;

/**
 * API response type for report download submission
 */
export interface ReportDownloadResponse {
  success: boolean;
  downloadId?: string;
  error?: string;
}
